if (!customElements.get('facet-sort-select')) {
  customElements.define(
    'facet-sort-select',
    class FacetSortSelect extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('select');
        this.details = this.querySelector('details');
        this.valueEl = this.querySelector('.facet-sort-select__value');
        this.options = this.querySelectorAll('.facet-sort-select__option');

        this.options.forEach((button) => button.addEventListener('click', this.onOptionClick.bind(this)));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
      }

      onOptionClick(event) {
        const button = event.currentTarget;
        const { value } = button.dataset;
        if (!value || this.select.value === value) {
          this.details.open = false;
          return;
        }

        this.select.value = value;
        this.valueEl.textContent = button.textContent.trim();

        this.options.forEach((option) => {
          const isActive = option.dataset.value === value;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.details.open = false;
        this.select.dispatchEvent(new Event('input', { bubbles: true }));
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.details.open = false;
        }
      }
    }
  );
}
